import type { ResumeSkillCategory } from 'types/resume';
import styles from './SkillsSection.module.scss';

interface Props {
  skills: ResumeSkillCategory[];
}

export default function SkillsSection({ skills }: Props) {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Skills</h2>
      <div className={styles.groups}>
        {skills.map(group => (
          <div key={group.category} className={styles.group}>
            <h3 className={styles.groupLabel}>{group.category}</h3>
            <div className={styles.pills}>
              {group.items.map(skill => (
                <span key={skill} className={styles.pill}>{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
